import { FC } from 'react';

import { Grid, Box } from '@mui/material';

import ContentTypeRichText from '@/components/ContentTypeRichText';
import ImageAsset, { IImage } from '@/components/ImageAsset/ImageAsset';
import SubscriptionForm from '@/components/SubscriptionForm';
import { Maybe, ImageAsset as TImageAsset } from '@/types/generated';
import { ContentTypeRichTextContent } from '@/graphql/__generated/sdk';

import { noResultMessageContainerStyles, noResultsFoundMessageStyles } from './NoResultsView.styles';

interface INoResultsView {
	viewImage?: Maybe<TImageAsset>;
	viewMessage?: ContentTypeRichTextContent;
	locationId?: string;
}

const NoResultsView: FC<INoResultsView> = ({ viewImage, viewMessage, locationId }) => {
	const additionalSubscriptionData = locationId ? { subscribed_location_id: locationId } : null;

	return (
		<Grid
			data-test-id="modern_google_maps_no_results_section"
			item
			container
			md={12}
			sx={noResultMessageContainerStyles}
		>
			<Box sx={noResultsFoundMessageStyles}>
				{viewImage && (
					<ImageAsset
						desktopImage={viewImage?.desktopImage as IImage}
						mobileImage={viewImage?.mobileImage as IImage}
						isBackgroundImage={false}
						dataTestId="modern-google-map-no-result-image"
					/>
				)}
				{viewMessage?.json && (
					<ContentTypeRichText
						content={viewMessage}
						dataTestId="google_maps_no_results_section_richtext"
						contentMaxWidth="100%"
						disableGutters={true}
						disablePaddingOn={['Top', 'Bottom']}
						backgroundColor="transparent"
						docProps={{ textAlign: 'center' }}
					/>
				)}
				<SubscriptionForm additionalSubscriptionData={additionalSubscriptionData} />
			</Box>
		</Grid>
	);
};

export default NoResultsView;
